import { GroupResourceType } from '../types/zod/groupResource';
import { BareVenueRequest } from '../types/groupBooking';
import { timeCompare } from './time';

export const DEFAULT_TOUR_LEADER = 'Tour Leader';
export const DEFAULT_TOUR_LEADER_CABIN = 'TL Cabin';
export const DEFAULT_GUEST_EXPERIENCE = 'Guest Experience';
export const DEFAULT_GUESTS = 'Guests';
export const DEFAULT_CONTACT_NAME = 'Agent Name';
export const DEFAULT_EMBARK_DATE = 'Embark';
export const DEFAULT_DEBARK_DATE = 'Debark';
export const DEFAULT_GROUP_BOOKING = 'Group Event Details';

export function findVenueRequestDifferences(oldR: BareVenueRequest, newR: BareVenueRequest) {
  const changes: string[] = [];

  if (oldR.venue !== newR.venue) {
    changes.push('Venue');
  }

  if (oldR.name !== newR.name) {
    changes.push('Name');
  }

  if (oldR.numGuests !== newR.numGuests) {
    changes.push('Guest Count');
  }

  if (timeCompare(oldR.startTime, newR.startTime) !== 0) {
    changes.push('Time');
  }

  if (oldR.duration !== newR.duration) {
    changes.push('Duration');
  }

  if (oldR.date.getTime() !== newR.date.getTime()) {
    changes.push('Date');
  }

  if (oldR.dayIndex !== newR.dayIndex) {
    changes.push('Day');
  }

  if (
    oldR.resources
      .filter(resource => resource.resourceType === GroupResourceType.FB.valueOf())
      .map(r => `${r.name}-${r.amount}`)
      .join('|') !==
    newR.resources
      .filter(resource => resource.resourceType === GroupResourceType.FB.valueOf())
      .map(r => `${r.name}-${r.amount}`)
      .join('|')
  ) {
    changes.push('Food & Beverage');
  }

  if (
    oldR.resources
      .filter(resource => resource.resourceType === GroupResourceType.ENT.valueOf())
      .map(r => `${r.name}-${r.amount}`)
      .join('|') !==
    newR.resources
      .filter(resource => resource.resourceType === GroupResourceType.ENT.valueOf())
      .map(r => `${r.name}-${r.amount}`)
      .join('|')
  ) {
    changes.push('Entertainment');
  }

  if (
    oldR.resources
      .filter(resource => resource.resourceType === GroupResourceType.HSK.valueOf())
      .map(r => `${r.name}-${r.amount}`)
      .join('|') !==
    newR.resources
      .filter(resource => resource.resourceType === GroupResourceType.HSK.valueOf())
      .map(r => `${r.name}-${r.amount}`)
      .join('|')
  ) {
    changes.push('Housekeeping');
  }

  if (oldR.notes !== newR.notes) {
    changes.push('Notes');
  }

  if (oldR.files.map(f => f._id).join('|') !== newR.files.map(f => f._id).join('|')) {
    changes.push('Files');
  }

  if (oldR.venueConfig !== newR.venueConfig) {
    changes.push('Venue Configuration');
  }

  if (oldR.subgroup !== newR.subgroup) {
    changes.push('Subgroup');
  }

  return changes;
}
